"use strict";

import AssignmentService from "./AssignmentService";
import PlanningService from "./PlanningService";

export var assignmentService = new AssignmentService();
export var planningService = new PlanningService();
